function Footer() {
  return (
    <div className="footer">
			<p className="mb-0">WMS-RFID © {new Date().getFullYear()}{" "} | Developed By : <a href="#section">Ravelware</a>
			</p>
		</div>
  )
}

export default Footer